import { render, staticRenderFns } from "./SuiteAppOLD.vue?vue&type=template&id=da214d64&"
import script from "./SuiteAppOLD.vue?vue&type=script&lang=js&"
export * from "./SuiteAppOLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports